// src/components/DateSettingModal.js
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";

const defaultDateSetting = {
  startDate: "",
  endDate: "",
};

const DateSettingModal = ({ show, handleClose, data = {} }) => {
  const [formData, setFormData] = useState(defaultDateSetting);
  const [loading, setLoading] = useState(false);
  const { AsyncPatchAPICall } = useApi();

  // 🔹 Modal open -> existing data fill
  useEffect(() => {
    if (data?.startDate || data?.endDate) {
      setFormData({
        startDate: data.startDate ? data.startDate.slice(0, 16) : "",
        endDate: data.endDate ? data.endDate.slice(0, 16) : "",
      });
    }
  }, [data, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.startDate || !formData.endDate) {
      return toast.error("Both dates are required");
    }

    setLoading(true);

    const start = new Date(formData.startDate);
    const end = new Date(formData.endDate);

    if (start >= end) {
      toast.error("Start date must be earlier than End date");
      setLoading(false);
      return;
    }

    const payload = {
      startDate: new Date(formData.startDate),
      endDate: new Date(formData.endDate),
    };

    const result = await AsyncPatchAPICall("/airdrop/update-setting", payload);

    if (result?.success) {
      toast.success(result?.message || "Date updated successfully");
      handleClose(true); // refresh parent
    } else {
      toast.error(result?.errors?.[0] || "Something went wrong");
    }

    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}

      <Modal
        show={show}
        onHide={() => {
          handleClose();
          setFormData(defaultDateSetting);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Airdrop Date Setting</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Start Date */}
            <Form.Group className="mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="datetime-local"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
            </Form.Group>

            {/* End Date */}
            <Form.Group className="mb-3">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="datetime-local"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
              setFormData(defaultDateSetting);
            }}
          >
            Close
          </Button>

          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DateSettingModal;
